import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import AdeIcon from "assets/icons/ade.svg?react";
import CourtIcon from "assets/icons/court.svg?react";
import sanitizeHtml from "sanitize-html";
import { ItemKind } from "dto/IKindItems";
import { useTranslation } from "react-i18next";

const NameCell: FC<Props> = ({ element }) => {
  const { t } = useTranslation();

  const senderOrReceiver = element.IsIncoming
    ? element?.Sender
    : element.Receivers.map((r) => r.Name).join(", ");

  return (
    <div className={styles.wrapper}>
      {element.Kind === ItemKind.EDeliveryMessage && (
        <AdeIcon className={styles.iconPDF} />
      )}
      {element.Kind === ItemKind.CourtPortalDeliverance && (
        <CourtIcon className={styles.iconPDF} />
      )}
      <div className={`${styles.stack}`}>
        <div
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(senderOrReceiver ?? ""),
          }}
          className={styles.sender}
        ></div>
        <div
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(element.S1 ?? t("registry.noTitle")),
          }}
          className={styles.title}
        ></div>
      </div>
    </div>
  );
};

export default NameCell;
